var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M27.412 36.251c.14 0 .26-.044.36-.133a.45.45 0 00.152-.36.455.455 0 00-.151-.36.534.534 0 00-.36-.133l-1.65.001-.597-4.664h10.403c1.125 0 1.978-.288 2.559-.863.581-.575.872-1.43.872-2.568V6.412c0-1.137-.29-1.99-.872-2.559-.581-.569-1.434-.853-2.56-.853H4.432c-1.137 0-1.993.284-2.568.853S1 5.275 1 6.413V27.17c0 1.137.288 1.993.863 2.568s1.43.863 2.568.863h10.402l-.597 4.664h-1.667a.509.509 0 00-.342.132.458.458 0 00-.151.36c0 .152.05.272.151.36a.505.505 0 00.342.133h14.843zm8.08-6.635H4.489c-.834 0-1.46-.205-1.877-.616-.417-.41-.625-1.033-.625-1.867V6.45c0-.834.208-1.453.625-1.858.417-.404 1.043-.606 1.877-.606h31.005c.834 0 1.46.202 1.877.606.417.405.625 1.024.625 1.858v20.683c0 .834-.208 1.456-.625 1.867-.417.41-1.043.616-1.877.616z"
  }))));
}

export default SvgDesktop;